import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    FETCH_BRANDS,
    FETCH_BRANDS_FAILURE,
    FETCH_BRANDS_SUCCESS,
    FETCH_ITEMS,
    FETCH_ITEMS_FAILURE,
    FETCH_ITEMS_SUCCESS,
    FETCH_PANELS_IDS,
    FETCH_PANELS_IDS_FAILURE,
    FETCH_PANELS_IDS_SUCCESS,
    OPEN_MODAL,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: { errors: [], isSaving: false },
    fetchBrands: { data: [], error: null, isFetching: false },
    fetchItems: {
        data: { data: [], pagination: null },
        errors: [],
        isFetching: false,
    },
    isOpenModal: false,
    panelsIds: { data: [], errors: [], isFetching: false },
};

const addPanelsModalSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: [],
                isSaving: true,
            };
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                errors: action.payload,
                isSaving: false,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                isSaving: false,
            };
        },
        [FETCH_BRANDS]: (state) => {
            state.fetchBrands = {
                ...state.fetchBrands,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_BRANDS_FAILURE]: (state, action) => {
            state.fetchBrands = {
                ...state.fetchBrands,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_BRANDS_SUCCESS]: (state, action) => {
            state.fetchBrands = {
                ...state.fetchBrands,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEMS]: (state) => {
            state.fetchItems = {
                ...state.fetchItems,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ITEMS_FAILURE]: (state, action) => {
            state.fetchItems = {
                ...state.fetchItems,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ITEMS_SUCCESS]: (state, action) => {
            state.fetchItems = {
                ...state.fetchItems,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANELS_IDS]: (state) => {
            state.panelsIds = {
                ...state.panelsIds,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_PANELS_IDS_FAILURE]: (state, action) => {
            state.panelsIds = {
                ...state.panelsIds,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PANELS_IDS_SUCCESS]: (state, action) => {
            state.panelsIds = {
                data: action.payload,
                errors: [],
                isFetching: false,
            };
        },
        [OPEN_MODAL]: (state, action) => {
            state.isOpenModal = action.payload;
        },
    },
});

export const addPanelsModalActions = addPanelsModalSlice.actions;

export default addPanelsModalSlice.reducer;
